import { put } from 'redux-saga/effects';
import { exportCsvAlertsFail, exportCsvAlertsSuccess } from './actions';
import { exportCsvAlerts } from './backend';
import { makeErrorPayload } from '../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../shared/toast/redux/actions';

export function* exportCsvAlertsSaga(action) {
    try {
        const {
            alertLevel,
            jurisdiction,
            brandId,
            dismissType,
            dismissed,
            dismissedBy,
            excludeDismissType,
            pagination,
            playerId,
            ruleCategory,
            ruleType,
            sort,
            teamId,
            username
        } = action.payload;

        const response = yield exportCsvAlerts({
            alertLevel,
            jurisdiction,
            brandId,
            dismissType,
            dismissed,
            dismissedBy,
            excludeDismissType,
            ...pagination,
            ...sort,
            hasNextPage: null,
            playerId,
            ruleCategory,
            ruleType,
            teamId,
            username
        });

        yield saveBlob(response.data, 'alerts.csv');
        yield put(exportCsvAlertsSuccess());
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(exportCsvAlertsFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}

const saveBlob = (blob, fileName) => {
    let a = document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.download = fileName;
    a.dispatchEvent(new MouseEvent('click'));
};
